// extracted by mini-css-extract-plugin
export default {"LectureWrapper":"LectureSchedule_LectureWrapper__SaU+s","LectureList":"LectureSchedule_LectureList__b1Juc"};